import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import { renderSearchMultipleDropdown } from '../../common/form/FieldHelper';
import { renderSearchDropDown } from '../../common/form/FieldHelper';

class LocationDropdown extends Component {

  render() {

    const {
      form,
      multiple,
      name,
      searchFn,
      subsidiary,
      primary = true,
      excluded_locations,
      included_locations,
      minimum_should_match,
      currency,
      parent,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType='location'
          type='location'
          searchParams={{
            subsidiary,
            primary,
            excluded_locations,
            included_locations,
            currency,
            parent,
            minimum_should_match,
          }}
          valueField='id'
          component={ multiple ? renderSearchMultipleDropdown : renderSearchDropDown }
        />
      </div>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    searchFn: fetchDropdown
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(LocationDropdown);

